import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RoutesRecognized } from '@angular/router';
import { first, skip } from 'rxjs/operators';
import { NavigationHelper } from '../../helpers/navigation.helper';
import { StringManipulationHelper } from '../../helpers/string-manipulation.helper';
import { NavigationSegment } from '../../models/breadcrumb/breadcrumb-item.model';

@Component({
    selector: 'spv2-back-navigation-header',
    templateUrl: './back-navigation-header.component.html',
    styleUrls: ['./back-navigation-header.component.scss'],
    standalone: false
})
export class BackNavigationHeaderComponent implements OnInit {

  navigationSegments: NavigationSegment[] = [];
  prevItem: NavigationSegment;

  constructor(private readonly router: Router, private readonly activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    this.router.events.subscribe((val) => {
      if (val instanceof RoutesRecognized) {
        if (this.navigationSegments.length > 0) {

          if (this.isSameUrl(val.urlAfterRedirects, this.navigationSegments[this.navigationSegments.length - 1].routerLink)) {
            //We skip the first one in the pipe, because this seems to be the first route fragment every time. Why? Ask angular...
            this.activatedRoute.fragment.pipe(skip(1), first()).subscribe((fragment: string) => {
              this.navigationSegments[this.navigationSegments.length - 1].fragment = fragment
            });
          }
        }
      }

      if (val instanceof NavigationEnd) {
        let breadcrumbItems = NavigationHelper.getNaviationSegments(this.activatedRoute);
        if (breadcrumbItems.length > 0) {
          this.prevItem = this.navigationSegments.slice(-1)[0];
          this.activatedRoute.fragment.pipe(first()).subscribe((fragment: string) => {
            breadcrumbItems[breadcrumbItems.length - 1].fragment = fragment
          });
        }
        this.navigationSegments.push(breadcrumbItems.pop());
      }
    });
  }

  navigateBack() {
    if (this.navigationSegments.length > 1) {
      this.navigationSegments.pop();
      this.navigationSegments.pop();
    }
  }

  private isSameUrl(urlAfterRedirect: string, routerLinkLastSegment: string): boolean {
    let firstUrl = StringManipulationHelper.cleanUrlQueryParamsAndFragments(StringManipulationHelper.cleanSlashes(urlAfterRedirect));
    let secondUrl = StringManipulationHelper.cleanSlashes(routerLinkLastSegment);
    return firstUrl === secondUrl;
  }
}
